// extracted by mini-css-extract-plugin
export default {"container":"Um-z","bubbleNav":"Vm-z","graphic":"Wm-z","contact":"Xm-z"};